__turbopack_context__.v({
  "closeButton": "ThankYou-module__znQGdW__closeButton",
  "content": "ThankYou-module__znQGdW__content",
  "header": "ThankYou-module__znQGdW__header",
  "open": "ThankYou-module__znQGdW__open",
  "text": "ThankYou-module__znQGdW__text",
  "thankYou": "ThankYou-module__znQGdW__thankYou",
});
